export var convertToGAIndex = function convertToGAIndex(index) {
  return index + 1;
};